import React from "react";
import SidePanel from "../../../../components/SidePanel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MDBox from "../../../../materialDashboard/components/MDBox";
import TablesPanel from "./TablesPanel";
import StationPanel from "./StationPanel";
import Model1Panel from "./Model1Panel";
import Model23Panel from "./Model23Panel";
import IncidentPanel from "./IncidentPanel";
import Typography from "@mui/material/Typography";

const DataPanel = ({webgis}) => {
    const {featuresState, layersState, dataPanel} = webgis;
    const {isOpen, activeContentType, availableContents, setActiveContentType, close} = dataPanel;

    const {stationSelectedState, model23SelectedState, model1SelectedState, incidentSelectedState} = featuresState;

    const renderContent = () => {
        if (activeContentType?.endsWith('Table')) {
            return <TablesPanel webgis={webgis} activeTableId={activeContentType} onTableChange={setActiveContentType} />;
        }
        switch (activeContentType) {
            case 'station':
                return <StationPanel selectedFeatures={stationSelectedState.selectedFeatures}
                                     onDeSelectFeature={stationSelectedState.handleFeatureDeSelect}
                                     webgis={webgis} />;
            case 'model23':
                return <Model23Panel selectedFeatures={model23SelectedState.selectedFeatures}
                                     onDeSelectFeature={model23SelectedState.handleFeatureDeSelect} />;
            case 'model1':
                return <Model1Panel selectedFeatures={model1SelectedState.selectedFeatures}
                                    onDeSelectFeature={model1SelectedState.handleFeatureDeSelect}
                                    temporalState={layersState.temporalState} />;
            case 'incident':
                return <IncidentPanel selectedFeatures={incidentSelectedState.selectedFeatures}
                                      onDeSelectFeature={incidentSelectedState.handleFeatureDeSelect} />;
            default:
                return null;
        }
    };

    const activeContent = availableContents.find(c => c.type === activeContentType);
    const titleLabel = activeContent ? activeContent.label : "";

    const header = (
        <MDBox display="flex" alignItems="center" sx={{ flexGrow: 1, mr: 2 }}>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>{titleLabel}</Typography>
            {availableContents.length > 1 && (
                <Select
                    variant="outlined"
                    value={activeContentType}
                    onChange={(e) => setActiveContentType(e.target.value)}
                    size="small"
                    sx={{
                        minWidth: 150,
                        ml: 2,
                        height: "32px",
                        "& .MuiSelect-select": {
                            py: 0.5,
                            fontSize: "0.875rem"
                        }
                    }}
                >
                    {availableContents.filter(c => !c.hidden).map(content => (
                        <MenuItem key={content.type} value={content.type}>
                            {content.genericLabel || content.label}
                        </MenuItem>
                    ))}
                </Select>
            )}
        </MDBox>
    );

    return (
        <SidePanel open={isOpen} onClose={close} title={header} width="50vw">
            {renderContent()}
        </SidePanel>
    );
};

export default DataPanel;
